import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
export type TrafficFilters = { producerId: string; productId: string; offerId: string }
export type TrafficView = 'pages' | 'accesses' | 'players' | 'products' | 'offers'
export type TrafficOptions = {
  search?: string
  searchBy?: 'all' | 'id' | 'name' | 'url'
  sourcePage?: string
  sourceKind?: TrafficItem['sourceKind']
  sort?: 'traffic' | 'name' | 'recent'
  limit?: 20 | 25 | 50 | 100
}
export type TrafficItem = {
  id?: string | null
  name?: string | null
  pageCount?: string
  productCount?: string
  offerCount?: string
  playerCount?: string
  sourcePage: string | null
  sourceKind: 'PAGE' | 'ORIGIN_ONLY' | 'UNAVAILABLE'
  redirects?: string
  arrivalId?: string
  producerId?: string
  productId?: string
  productName?: string
  offerId?: string | null
  offerName?: string | null
  declaredPage?: string | null
  arrivedAt?: string
  lastArrivedAt?: string
}
export function useCheckoutTraffic(
  filters: TrafficFilters,
  view: TrafficView,
  offset: number,
  options: TrafficOptions = {},
) {
  return useQuery({
    queryKey: ['admin', 'checkout-traffic', filters, view, offset, options],
    enabled: view !== 'accesses' || Boolean(options.sourcePage || options.sourceKind),
    queryFn: () => {
      const search = new URLSearchParams({
        view,
        offset: String(offset),
        limit: String(options.limit ?? 25),
      })
      for (const [key, value] of Object.entries(filters))
        if (value.trim()) search.set(key, value.trim())
      if (options.search?.trim()) search.set('search', options.search.trim())
      if (options.searchBy) search.set('searchBy', options.searchBy)
      if (options.sourcePage?.trim()) search.set('sourcePage', options.sourcePage.trim())
      if (options.sourceKind) search.set('sourceKind', options.sourceKind)
      if (options.sort) search.set('sort', options.sort)
      return apiFetch<{ items: TrafficItem[]; hasMore: boolean; total?: number }>(
        `/admin/checkout-traffic?${search}`,
      )
    },
  })
}
